import template from './menu.html';
import controller from './menu.controller';
import './menu.scss';

export default {
	template,
	bindings: {},
	controller,
};
